(function () {
  var WIDGET_ID = 'navura-chat-v2';
  var OBSERVER_TIMEOUT = 12000;

  function nativeParts() {
    var host = document.getElementById('ads-agent-host');
    var root = host && host.shadowRoot;
    var entry = root && root.querySelector('[data-testid="entrypoint"]');
    var trigger = root && (root.querySelector('[data-testid="entrypoint"] [role="button"]') || entry);
    return { host: host, entry: entry, trigger: trigger };
  }

  function isStandaloneApp() {
    return window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true ||
      document.referrer.indexOf('android-app://') === 0;
  }

  var clarityLauncherObserver = null;

  function guardClarityLauncher(root) {
    if (!root) return;
    if (isStandaloneApp()) {
      var existingGuard = root.querySelector('#navura-clarity-launcher-guard');
      if (existingGuard) existingGuard.remove();
      return;
    }

    function ensureGuardStyle() {
      if (root.querySelector('#navura-clarity-launcher-guard')) return;
      var style = document.createElement('style');
      style.id = 'navura-clarity-launcher-guard';
      style.textContent = '[data-testid="entrypoint"]{display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important}';
      root.appendChild(style);
    }

    ensureGuardStyle();

    if (!clarityLauncherObserver && typeof MutationObserver !== 'undefined') {
      clarityLauncherObserver = new MutationObserver(ensureGuardStyle);
      clarityLauncherObserver.observe(root, { childList: true });
    }
  }

  function hideElement(element) {
    if (!element) return;
    element.style.setProperty('display', 'none', 'important');
    element.style.setProperty('visibility', 'hidden', 'important');
    element.style.setProperty('opacity', '0', 'important');
    element.style.setProperty('pointer-events', 'none', 'important');
  }

  function suppressLegacyNode(node) {
    if (!node || node.nodeType !== 1) return;
    var selector = '#chat-popup-iframe-bottom, iframe[title*="BiteSpeed" i], iframe[src*="bitespeed" i], iframe[src*="whatsapp" i]';
    if (node.matches && node.matches(selector)) hideElement(node);
    if (node.querySelectorAll) node.querySelectorAll(selector).forEach(hideElement);

    var links = [];
    if (node.matches && node.matches('a[href*="wa.me"], a[href*="whatsapp.com"]')) links.push(node);
    if (node.querySelectorAll) {
      node.querySelectorAll('a[href*="wa.me"], a[href*="whatsapp.com"]').forEach(function (link) {
        links.push(link);
      });
    }

    links.forEach(function (link) {
      if (link.closest('#' + WIDGET_ID)) return;
      var parent = link;
      while (parent && parent !== document.body) {
        if (getComputedStyle(parent).position === 'fixed') {
          hideElement(parent);
          break;
        }
        parent = parent.parentElement;
      }
    });
  }

  function suppressInitialLegacyWidgets() {
    suppressLegacyNode(document.body);
  }

  function watchForLateWidgets() {
    if (typeof MutationObserver === 'undefined') return;

    // Watch only direct body insertions. A subtree observer made every app
    // widget mutation scan the entire mobile page while third-party widgets
    // were mounting.
    var observer = new MutationObserver(function (records) {
      var shouldScan = records.some(function (record) {
        return Array.prototype.some.call(record.addedNodes, function (node) {
          if (!node || node.nodeType !== 1) return false;
          var legacySelector = '#chat-popup-iframe-bottom, iframe[title*="BiteSpeed" i], iframe[src*="bitespeed" i], iframe[src*="whatsapp" i]';
          var whatsappSelector = 'a[href*="wa.me"], a[href*="whatsapp.com"]';
          return (node.matches && (node.matches(legacySelector) || node.matches(whatsappSelector))) ||
            (node.querySelector && (node.querySelector(legacySelector) || node.querySelector(whatsappSelector)));
        });
      });

      if (shouldScan) suppressInitialLegacyWidgets();
    });

    observer.observe(document.body, { childList: true });
    window.setTimeout(function () {
      observer.disconnect();
    }, Math.min(OBSERVER_TIMEOUT, 6000));
  }

  function enableNativeClarityLauncher(root) {
    if (!root) return;
    var guard = root.querySelector('#navura-clarity-launcher-guard');
    if (guard) guard.remove();

    var style = root.querySelector('#navura-clarity-pwa-native');
    if (!style) {
      style = document.createElement('style');
      style.id = 'navura-clarity-pwa-native';
      style.textContent =
        '[data-testid="entrypoint"]{' +
        'display:flex!important;visibility:visible!important;opacity:1!important;' +
        'pointer-events:auto!important;right:16px!important;' +
        'bottom:calc(172px + env(safe-area-inset-bottom))!important;' +
        'margin:0!important;z-index:2147482999!important}';
      root.appendChild(style);
    }
  }

  function installClarityGuardWhenReady() {
    var attempts = 0;

    function tryInstall() {
      var parts = nativeParts();
      if (parts.host && parts.host.shadowRoot) {
        if (isStandaloneApp()) enableNativeClarityLauncher(parts.host.shadowRoot);
        else guardClarityLauncher(parts.host.shadowRoot);
        return;
      }

      attempts += 1;
      if (attempts < 25) window.setTimeout(tryInstall, 200);
    }

    tryInstall();
  }

  var claritySession = {
    observer: null,
    checkTimer: null,
    failTimer: null,
    scrollState: null
  };

  function captureScrollState() {
    claritySession.scrollState = {
      x: window.scrollX,
      y: window.scrollY,
      htmlOverflow: document.documentElement.style.overflow,
      htmlPosition: document.documentElement.style.position,
      bodyOverflow: document.body.style.overflow,
      bodyPosition: document.body.style.position,
      bodyTop: document.body.style.top,
      bodyWidth: document.body.style.width
    };
  }

  function restorePageScroll() {
    var state = claritySession.scrollState;
    if (!state) return;

    var agentFixedBody = document.body.style.position === 'fixed' && state.bodyPosition !== 'fixed';
    document.documentElement.style.overflow = state.htmlOverflow;
    document.documentElement.style.position = state.htmlPosition;
    document.body.style.overflow = state.bodyOverflow;
    document.body.style.position = state.bodyPosition;
    document.body.style.top = state.bodyTop;
    document.body.style.width = state.bodyWidth;
    claritySession.scrollState = null;

    // Only restore coordinates if Clarity actually converted the body to a
    // fixed scroll-lock. Normal drawer closes must not repaint or jump the page.
    if (agentFixedBody && Math.abs(window.scrollY - state.y) > 2) {
      window.requestAnimationFrame(function () {
        window.scrollTo(state.x, state.y);
      });
    }
  }

  function clearClarityState() {
    if (claritySession.observer) claritySession.observer.disconnect();
    if (claritySession.checkTimer) window.clearTimeout(claritySession.checkTimer);
    if (claritySession.failTimer) window.clearTimeout(claritySession.failTimer);
    claritySession.observer = null;
    claritySession.checkTimer = null;
    claritySession.failTimer = null;
    document.documentElement.classList.remove('navura-clarity-active');
    restorePageScroll();
  }

  function isVisibleAgentSurface(element) {
    if (!element || element.closest('[data-testid="entrypoint"]')) return false;
    var style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) < 0.05) {
      return false;
    }

    var rect = element.getBoundingClientRect();
    return rect.width >= 80 &&
      rect.height >= 80 &&
      rect.right > 0 &&
      rect.bottom > 0 &&
      rect.left < window.innerWidth &&
      rect.top < window.innerHeight;
  }

  function hasOpenAgentSurface(root) {
    if (!root) return false;
    var selectors = [
      '[role="dialog"]',
      '[aria-modal="true"]',
      '[data-testid*="drawer"]',
      '[data-testid*="conversation"]',
      '[data-testid*="assistant"]'
    ];
    var surfaces = root.querySelectorAll(selectors.join(','));
    return Array.prototype.some.call(surfaces, isVisibleAgentSurface);
  }

  function watchClarityAgent(root) {
    function checkClosed() {
      var entry = root && root.querySelector('[data-testid="entrypoint"]');
      if (entry && !hasOpenAgentSurface(root)) clearClarityState();
    }

    if (typeof MutationObserver !== 'undefined' && root) {
      claritySession.observer = new MutationObserver(function () {
        if (claritySession.checkTimer) window.clearTimeout(claritySession.checkTimer);
        claritySession.checkTimer = window.setTimeout(checkClosed, 250);
      });
      claritySession.observer.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-hidden', 'aria-expanded', 'class', 'style']
      });
    }

    claritySession.failTimer = window.setTimeout(function () {
      if (!hasOpenAgentSurface(root)) clearClarityState();
    }, 1400);
  }

  function openClarityAgent() {
    if (document.documentElement.classList.contains('navura-clarity-active')) return;

    captureScrollState();
    document.documentElement.classList.add('navura-clarity-active');
    var attempts = 0;

    function tryOpen() {
      var parts = nativeParts();
      if (parts.trigger) {
        guardClarityLauncher(parts.host && parts.host.shadowRoot);
        try {
          parts.trigger.click();
          watchClarityAgent(parts.host && parts.host.shadowRoot);
        } catch (error) {
          clearClarityState();
        }
        return;
      }

      attempts += 1;
      if (attempts < 25) {
        window.setTimeout(tryOpen, 200);
      } else {
        clearClarityState();
      }
    }

    tryOpen();
  }

  window.addEventListener('pagehide', clearClarityState);

  function init() {
    var existing = document.getElementById(WIDGET_ID);
    if (existing) existing.remove();

    var widget = document.createElement('div');
    widget.id = WIDGET_ID;
    widget.innerHTML = '<div id="navura-chat-v2-menu" aria-hidden="true"><a class="navura-chat-v2-option navura-chat-v2-wa" href="https://wa.me/917505529930" target="_blank" rel="noopener"><img class="navura-chat-v2-whatsapp-icon" src="' + (window.navuraWhatsappIconUrl || '') + '" alt="" width="26" height="26" aria-hidden="true"><span>Chat on WhatsApp</span></a><button class="navura-chat-v2-option navura-chat-v2-ai" type="button"><svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l1.5 4.5L18 8l-4.5 1.5L12 14l-1.5-4.5L6 8l4.5-1.5L12 2Zm6 10 .9 2.6 2.6.9-2.6.9-.9 2.6-.9-2.6-2.6-.9 2.6-.9L18 12Z"/></svg><span>Shop with AI</span></button></div><button id="navura-chat-v2-toggle" type="button" aria-label="Open chat options" aria-expanded="false"><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 11.5a7.5 7.5 0 0 1-8 7.5 8.5 8.5 0 0 1-3.3-.7L4 20l1.4-4A8 8 0 1 1 20 11.5Z" stroke="currentColor" stroke-width="1.8"/><circle cx="8.5" cy="11.5" r="1" fill="currentColor"/><circle cx="12" cy="11.5" r="1" fill="currentColor"/><circle cx="15.5" cy="11.5" r="1" fill="currentColor"/></svg></button>';
    document.body.appendChild(widget);

    var toggle = widget.querySelector('#navura-chat-v2-toggle');
    var menu = widget.querySelector('#navura-chat-v2-menu');
    var drag = null;
    var moved = false;

    function setOpen(value) {
      widget.classList.toggle('open', value);
      toggle.setAttribute('aria-expanded', String(value));
      toggle.setAttribute('aria-label', value ? 'Close chat options' : 'Open chat options');
      menu.setAttribute('aria-hidden', String(!value));
    }

    function safeFloor() {
      var nav = document.querySelector('.navura-bottom-nav');
      return nav && getComputedStyle(nav).display !== 'none'
        ? nav.getBoundingClientRect().top - 24
        : window.innerHeight - 16;
    }

    function clamp(x, y) {
      var rect = widget.getBoundingClientRect();
      return {
        x: Math.max(12, Math.min(x, window.innerWidth - rect.width - 12)),
        y: Math.max(12, Math.min(y, safeFloor() - rect.height))
      };
    }

    toggle.addEventListener('pointerdown', function (event) {
      var rect = widget.getBoundingClientRect();
      drag = { x: event.clientX, y: event.clientY, left: rect.left, top: rect.top };
      moved = false;
      toggle.setPointerCapture(event.pointerId);
    });

    toggle.addEventListener('pointermove', function (event) {
      if (!drag) return;
      var dx = event.clientX - drag.x;
      var dy = event.clientY - drag.y;
      if (Math.abs(dx) + Math.abs(dy) > 5) moved = true;
      if (!moved) return;
      var position = clamp(drag.left + dx, drag.top + dy);
      widget.style.left = position.x + 'px';
      widget.style.top = position.y + 'px';
      widget.style.right = 'auto';
      widget.style.bottom = 'auto';
      setOpen(false);
    });

    toggle.addEventListener('pointerup', function () {
      drag = null;
    });

    toggle.onclick = function (event) {
      event.stopPropagation();
      if (!moved) setOpen(!widget.classList.contains('open'));
      moved = false;
    };

    var aiOption = widget.querySelector('.navura-chat-v2-ai');
    if (isStandaloneApp()) {
      document.documentElement.classList.add('navura-standalone-app');
      aiOption.remove();
      clearClarityState();
      var native = nativeParts();
      if (native.host && native.host.shadowRoot) enableNativeClarityLauncher(native.host.shadowRoot);
    } else {
      aiOption.addEventListener('click', function () {
        setOpen(false);
        openClarityAgent();
      });
    }

    document.addEventListener('click', function (event) {
      if (!widget.contains(event.target)) setOpen(false);
    });

    suppressInitialLegacyWidgets();
    watchForLateWidgets();
    installClarityGuardWhenReady();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();